module.exports = __webpack_public_path__ + "img/129.b5a83153.jpg";